import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FlexLayoutModule} from '@angular/flex-layout';
import {InputMaskModule} from '@ngneat/input-mask';
import {CurrencyChipComponent} from './currency-chip.component';
import {DirectiveLibraryModule} from '../../directives/directive-library.module';
import {AngularMaterialLibraryModule} from '../../angular-material/angular-material-library.module';
import {PipeLibraryModule} from '../../pipes/pipe-library.module';

const modules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  FlexLayoutModule,
  AngularMaterialLibraryModule,
  InputMaskModule,
  DirectiveLibraryModule,
]

@NgModule({
    imports: [
        ...modules,
        PipeLibraryModule,
        CurrencyChipComponent
    ],
    exports: [
        CurrencyChipComponent,
        ...modules,
    ]
})
export class CurrencyChipModule {

}
